export const ROLE = {
    NONE: "NONE",   //권한 없음
    READ: "READ",   //읽기 권한
    WRITE: "WRITE"  //쓰기 권한
}

//개발자(AA)
const developerRole = {
    dashboard: ROLE.WRITE,
    opbMng: ROLE.WRITE,
    firmwarwMng: ROLE.WRITE,
    opbState: ROLE.WRITE,
    screenMod: ROLE.WRITE,
    contentsAllMng: ROLE.WRITE,
    contentsMng: ROLE.WRITE,
    adMng: ROLE.WRITE,
    bottomContentsMng: ROLE.WRITE,
    noticeMng: ROLE.WRITE,
    templateMng: ROLE.WRITE,
    codeMng: ROLE.WRITE,
    boardinfoMng: ROLE.WRITE,
    userMng: ROLE.WRITE,
}
//운영자(BA)
const supervisorRole = {
    dashboard: ROLE.WRITE,
    opbMng: ROLE.WRITE,
    firmwareMng: ROLE.WRITE,
    opbState: ROLE.WRITE,
    screenMod: ROLE.WRITE,
    contentsAllMng: ROLE.WRITE,
    contentsMng: ROLE.WRITE,
    adMng: ROLE.WRITE,
    bottomContentsMng: ROLE.WRITE,
    noticeMng: ROLE.WRITE,
    templateMng: ROLE.WRITE,
    codeMng: ROLE.WRITE,
    boardinfoMng: ROLE.WRITE,
    userMng: ROLE.WRITE,
}
//지사운영자(CA)
const administratorRole = {
    dashboard: ROLE.WRITE,
    opbMng: ROLE.WRITE,
    firmwareMng: ROLE.NONE,
    opbState: ROLE.WRITE,
    screenMod: ROLE.WRITE,
    contentsAllMng: ROLE.WRITE,
    contentsMng: ROLE.READ,
    adMng: ROLE.READ,
    bottomContentsMng: ROLE.READ,
    noticeMng: ROLE.READ,
    templateMng: ROLE.WRITE,
    codeMng: ROLE.NONE,
    boardinfoMng: ROLE.NONE,
    userMng: ROLE.NONE,
}
//관리사무소(DA)
const userRole = {
    dashboard: ROLE.NONE,
    opbMng: ROLE.NONE,
    firmwareMng: ROLE.NONE,
    opbState: ROLE.WRITE,
    screenMod: ROLE.WRITE,
    contentsAllMng: ROLE.NONE,
    contentsMng: ROLE.WRITE,
    adMng: ROLE.WRITE,
    bottomContentsMng: ROLE.WRITE,
    noticeMng: ROLE.WRITE,
    templateMng: ROLE.READ,
    codeMng: ROLE.NONE,
    boardinfoMng: ROLE.NONE,
    userMng: ROLE.NONE,
}
//비회원(FA)
const othersRole = {
    dashboard: ROLE.NONE,
    opbMng: ROLE.NONE,
    firmwareMng: ROLE.NONE,
    opbState: ROLE.NONE,
    screenMod: ROLE.NONE,
    contentsAllMng: ROLE.NONE,
    contentsMng: ROLE.NONE,
    adMng: ROLE.NONE,
    bottomContentsMng: ROLE.NONE,
    noticeMng: ROLE.NONE,
    templateMng: ROLE.NONE,
    codeMng: ROLE.NONE,
    boardinfoMng: ROLE.NONE,
    userMng: ROLE.NONE,
}

export const roles = {
    developerRole,      //개발자(AA)
    supervisorRole,     //운영자(BA)
    administratorRole,  //지사운영자(CA)
    userRole,           //관리사무소(DA)
    othersRole          //비회원(FA)
};